const featured = {
  light: '#C0B4FB',
  main: '#6448F1',
  dark: '#5338E1',
  contrastText: '#ffffff',
};

export default featured;
